<template lang="pug">
    v-dialog(v-model="dialog" v-if="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" )
        template
            v-snackbar(
                v-model="snackbar"
                :timeout="10000"
                color='error'
            ) {{ snackbarMessage }} 
            v-toolbar(dark dense color="red" class="navFixed")
                v-toolbar-title i-Permit Preview
                v-spacer
                v-toolbar-title(v-if=" ip.ipStatus !== 10 && getApproveStatus(ip.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipWorkflow))}}
                v-toolbar-title(v-else-if="getApproveStatus(ip.ipWorkflow) == '8'") Rejected on {{formatDate(getApproveDate(ip.ipWorkflow))}}
                v-toolbar-items
                    v-btn(v-if="dialogType !== 'creator' && isCurrentApprover()" @click.stop="approvalDialog = true" color="red" depressed title='Approval' class="blink") 
                        v-icon(title="Approval") assignment_turned_in
                        | &nbsp; Approval
                    v-dialog(v-if="dialogType !== 'creator' && isCurrentApprover()" v-model="approvalDialog" persistent max-width="500px")
                        v-card()
                            v-card-title(class="headline grey lighten-2") Approval Form
                            v-card-text
                                v-layout(wrap)
                                    v-flex(xs12)
                                        v-radio-group(v-model="approval" row)
                                            v-radio(label="Approve" color="success" value="7")
                                            v-radio(v-if="ip.ipStatus !== 10" label="Reject" color="red" value="8")
                                            v-radio(v-if="ip.ipStatus == 10" label="Need Review" color="yellow darken-4" value="11")
                                            
                                    v-flex(xs12)
                                        v-textarea(
                                            v-model="comment"
                                            filled
                                            label="Comment (Optional)"
                                            value=""
                                        )
                            v-card-actions
                                v-spacer
                                v-btn(text @click.native="approvalDialog = false") Close
                                v-btn(:disabled="!approval" text :loading="approvalDialog2" color="blue darken-1" @click="approvalDialog2 = true") Submit
                                v-dialog(
                                    v-model="approvalDialog2"
                                    hide-overlay
                                    persistent
                                    width="300")
                                    v-card(color="primary" dark)
                                    v-card-text Processing. Please wait!
                                        v-progress-linear(indeterminate color="white" class="mb-0")
                    v-btn(v-if="this.ip.ipStatus == 4 || this.ip.ipStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
                        v-icon share
                        | &nbsp; Share
                        v-dialog(v-model="share" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Share
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        ShareNetwork(
                                            v-for="network in networks"
                                            :key="network.key"
                                            class="ma-3 pa-3 green"
                                            :network="network.network"
                                            style="border-radius: 10px; box-shadow: -2px 4px #888888;"
                                            :url="shortenUrl"
                                            :title="sharing.title"
                                            :description="sharing.description"
                                        ) 
                                            i(:class="network.icon" style="color:white")
                                            span(class="ma-3" style="color:white") {{ network.name }}
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="share = false") Close
                    v-btn(@click="ip.ipStatus == 4 || ip.ipStatus == 8 ? print = true : printIP(ip._id)" color="red" depressed title="Print" )
                        v-icon print
                        | &nbsp; Print
                        v-dialog(v-model="print" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Print Document
                                v-alert(:value='true' color="success")
                                    h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        v-btn(@click="printIP(ip._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-print" style="color:white")
                                            span(class="ma-3" style="color:white") Print
                                        v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                            span(class="ma-3" style="color:white") Share
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="print = false") Close
                    v-btn(@click.native="dialog = false" color="red" depressed)
                        v-icon(title="Close") cancel
                        | &nbsp; Close
            v-list(class="print-bg padTop60")
                div(:id="ip._id")
                    .page(size="Auto" style="height:800px")
                        div(class="view-width" style="font-size:10px;")
                            div(v-if="ip.ipStatus == 4" id="background")
                                p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                img(src="../assets/Approve.png" class="imgWatermark")
                                p(class="fontWatermarkDown" ) {{ip.ipNo}}
                            div(v-else-if="ip.ipStatus == 8" id="background")
                                p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                img(src="../assets/reject.png" class="imgWatermark")
                                p(class="fontWatermarkDown" ) {{ip.ipNo}}
                            div(v-else-if="ip.ipStatus == 13" id="background")
                                p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                img(src="../assets/Auto Canceled.png" class="imgWatermark")
                                p(class="fontWatermarkDown" ) {{ip.ipNo}}
                            div(v-else-if="ip.ipStatus == 14" id="background")
                                p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                img(src="../assets/Auto Rejected.png" class="imgWatermark")
                                p(class="fontWatermarkDown" ) {{ip.ipNo}}
                            div(v-else-if="ip.ipStatus == 15" id="background")
                                p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                img(src="../assets/Auto Dropped.png" class="imgWatermark")
                                p(class="fontWatermarkDown" ) {{ip.ipNo}}
                            div(v-else-if="ip.ipStatus == 12" id="background")
                                p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                img(src="../assets/Done.png" class="imgWatermark")
                                p(class="fontWatermarkDown" ) {{ip.ipNo}}
                            table(class="view-width tableInput" style="margin-top:10px;")
                                tbody
                                    tr
                                        td( class="align-center" width="150" rowspan="3")
                                            img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                        td(class="align-center") SINARMAS MINING SYSTEM
                                        td( class="align-center" width="150" rowspan="3") 
                                            img(class="verMiddle" :src="`${API_URL}/qr/generate/?ipNo=${ip.ipNo}&formCode=${ip.ipForm}`" style="width:80px;margin:2px 0;")
                                    tr
                                        td(class="align-center") FORMULIR
                                    tr
                                        td(class="align-center") {{ formName[ip.ipForm] }}
                            
                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                thead
                                    tr
                                        td(class="headerTable" width="150" colspan="7") I. INFORMASI UMUM
                                tbody(style="border: 1px solid black")
                                    
                                    tr
                                        td(width="150" class="headerTable") Judul Pekerjaan
                                        td(colspan="3") {{ ip.ipJudulPekerjaan }}
                                    tr
                                        td(width="150" class="headerTable") Penanggung Jawab
                                        td(colspan="3") {{ ip.ipPemegangIzin.name }}
                                    tr
                                        td(width="150" class="headerTable") Departmen PIC
                                        td(colspan="3") {{ ip.ipDeptDivisi }}
                                    tr
                                        td(width="150" class="headerTable") Perusahaan PIC Tamu
                                        td(colspan="3") {{ ip.ipPerusahaan }}
                                    tr
                                        td(width="150" class="headerTable") Tujuan Kunjungan
                                        td(colspan="3") {{ ip.ipTujuanKunjungan }}
                                    tr
                                        td(class="headerTable") Tanggal Kunjungan
                                        td(width="250") {{ formatDateOnly(ip.ipTanggalKunjungan) }}
                                        td(width="100" class="headerTable") Sampai Tanggal
                                        td {{formatDateOnly(ip.ipSelesaiKunjungan)}}
                                    tr
                                        td(width="150" class="headerTable") Lokasi Kunjungan
                                        td(colspan="3") {{locations.join(', ')}}
                                    tr
                                        td(width="150" class="headerTable") Subllokasi
                                        td(colspan="3") {{ ip.ipDetailLocation }}
                                    tr
                                        td(class="headerTable") Klasifikasi
                                        td(colspan="3") {{ ip.ipKlasifikasi }}
                                    tr
                                        td(class="headerTable") Akomodasi
                                        td(colspan="3") {{ ip.ipAkomodasi }}
                                    tr
                                        td(class="headerTable") APD
                                        td(colspan="3") {{ ip.ipApd }}
                                    tr
                                        td(class="headerTable") Transportasi
                                        td(colspan="3") {{ ip.ipTransportasi }}
                            
                            table(style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                                    tbody(v-if="ip.ipItinerary != null && (ip.ipItinerary.docPendukung || ip.ipItineraryUrl)") 
                                        v-btn(tile text @click="download(ip.ipItinerary.docPendukung ? ip.ipItinerary.docPendukung : ip.ipItineraryUrl)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal" height="auto") 
                                            tr
                                                td(style="padding-left:1px" ) 
                                                    v-icon(small) mdi-attachment
                                                td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                                td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                                    img(src="../assets/check.png" width="10" )
                                    tbody(v-else)
                                        tr
                                            td(style="padding-left:1px" ) 
                                                v-icon(small) mdi-attachment
                                            td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                            td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                                img(src="../assets/close.png" width="10" class="verMiddle")

                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class=" headerTable" width="150" colspan="8") II DAFTAR TAMU
                                    tr
                                        td(class="align-center headerTable" width="50") Nama Tamu
                                        td(class="align-center headerTable" width="20") Perusahaan
                                        td(class="align-center headerTable" width="20") Jabatan
                                        td(class="align-center headerTable" width="20") Email
                                        td(class="align-center headerTable" width="50") No Handpone
                                        td(class="align-center headerTable" width="20") Status
                                    tr(v-for="(item, index) in ip.ipVisitors" :key="index")
                                        td {{item.name}}
                                        td {{item.company}}
                                        td {{item.position}}
                                        td {{item.email}}
                                            td {{item.phone}}
                                        td {{config.statusVisitor[item.status].name}}

                            table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                tbody
                                    tr
                                        td(class="headerTable pl-2" colspan="11") III PENGESAHAN
                                    tr
                                        td(class="pl-2" colspan="6") 
                                            b Catatan:
                                            ul
                                            li Pengajuan Internal BIB ditandatangani oleh pengawas area kerja  & Dept. Head Custodian, kemudian divalidasi oleh OHS Operation masing-masing area.
                                            li Jika pengajuan izin dari mitra kerja maka harus ditandatangani oleh PJO dan penanggung jawab area, serta divalidasi dahulu oleh praktisi safety.
                            table(class="view-width tableCollapse tableInput")
                                tbody
                                    tr
                                        td(class="headerTable pl-2" rowspan="4" width="5%") Disetujui oleh
                                        td(class="headerTable align-center" width="20%") Nama
                                        td(class="headerTable align-center" width="20%") Jabatan
                                        td(class="headerTable align-center" width="20%") Tanggal
                                        td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                    tr
                                        td
                                            div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                br
                                                | {{ ip.ipWorkflow[0].name }}
                                                br
                                            div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                br
                                                | {{ ip.ipWorkflow[0].admin_reject == true ? ip.ipWorkflow[0].admin_detail.name : ip.ipWorkflow[0].name }}
                                                br
                                            div(v-else class="emptySign")
                                        td
                                            div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                br
                                                | {{ ip.ipWorkflow[0].title }}
                                                br
                                            div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                br
                                                | {{ ip.ipWorkflow[0].admin_reject == true ? 'Admin' : ip.ipWorkflow[0].title }}
                                                br
                                            div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[0].postAs, 0, ip.ipForm) }}
                                        td
                                            div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                br
                                                | {{approvalTime(ip.ipWorkflow[0].date)}}
                                                br
                                            div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                br
                                                | {{approvalTime(ip.ipWorkflow[0].date)}}
                                                br
                                            div(v-else class="emptySign")
                                        td
                                            div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                img(src="../assets/check-64.png" style="width:25px;")
                                            div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                img(src="../assets/close-64.png" style="width:25px;")
                                            div(v-else class="emptySign")
                                        td
                                            p(v-if="ip.ipWorkflow[0].comment || ''" class="align-left top-align comment") {{ ip.ipWorkflow[0].comment }}
                                            div(v-else class="emptySign")
                                    tr
                                        td
                                            div(v-if="ip.ipWorkflow[1].status == 7" class="approved")
                                                br
                                                | {{ getNameApproverKTT(ip.ipWorkflow[1]) }}
                                                br
                                            div(v-else-if="ip.ipWorkflow[1].status == 8" class="approved")
                                                br
                                                | {{ ip.ipWorkflow[1].admin_reject == true ? ip.ipWorkflow[1].admin_detail.name : getNameApproverKTT(ip.ipWorkflow[1]) }}
                                                br
                                            div(v-else class="emptySign")
                                        td
                                            div(v-if="ip.ipWorkflow[1].status == 7" class="approved")
                                                br
                                                | {{ getTitleApprover(ip.ipWorkflow[1]) }}
                                                br
                                            div(v-else-if="ip.ipWorkflow[1].status == 8" class="approved")
                                                br
                                                | {{ ip.ipWorkflow[1].admin_reject == true ? 'Admin' : getTitleApprover(ip.ipWorkflow[1]) }}
                                                br
                                            div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[1].postAs, 1, ip.ipForm) }}
                                        td
                                            div(v-if="ip.ipWorkflow[1].status == 7" class="approved")
                                                br
                                                | {{approvalTime(ip.ipWorkflow[1].date)}}
                                                br
                                            div(v-else-if="ip.ipWorkflow[1].status == 8" class="approved")
                                                br
                                                | {{approvalTime(ip.ipWorkflow[1].date)}}
                                                br
                                            div(v-else class="emptySign")
                                            
                                        td(style="position: relative;")
                                            div(v-if="ip.ipWorkflow[1].status == 7" class="approved")
                                                img(src="../assets/check-64.png" style="width:25px;")

                                            div(v-else-if="ip.ipWorkflow[1].status == 8" class="approved")
                                                img(src="../assets/close-64.png" style="width:25px;")

                                            div(v-else class="emptySign")

                                            div(
                                                v-if="isKTTSubstitute(ip.ipWorkflow[1])"
                                                class="custom__position-for"
                                            ) for 
                                        td
                                            p(v-if="ip.ipWorkflow[1].comment || ''" class="align-left top-align comment") {{ ip.ipWorkflow[1].comment }}
                                            div(v-else class="emptySign")


</template>

<script>
import axios from 'axios';
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import printJS from 'print-js';
import dayJS from 'dayjs';
import { handleGlobalErrorApproval } from '../helper/handleGlobalError.js';
export default {
  name: 'IzinTamuView',
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object
  },
  data: () => ({
    formName: config.FormName,
    config: config.default,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    ipPengesahanApproval : null,
    ipClosingResubmitted : null,
    ipClosingSubmitted : null,
    ipDocPengesahan : null,
    approval: null,
    share: false,
    print: false,
    snackbar: false,
    snackbarMessage: ''
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl", 'dateFormat']),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  mounted() {
    },
    methods: {
    jabatanDetail: helper.jabatanDetail,
    dayjs(val = undefined) {
        return dayJS(val);
    },
    download(file) {
        if ( this.ip.ipItinerary.docPendukung ) {
            this.$downloadFile(file);
        } else {
            window.open(file, '_blank');
        }
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share}).then(() => {
            this.share = true;
        });
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css",  '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    formatDateOnly: helper.formatDateOnly,
    getApproveStatus(wf){
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        return helper.isApprover(
            this.$store.getters.isAuthenticated,
            this.ip,
            this.approvalUser
        );
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    },
    getNameApproverKTT(item) {
        return helper.getKTTApproverName(item)
    },
    isKTTSubstitute(item) {
        return helper.isKTTSubstitute(item)
    },
    getTitleApprover(item) {
        if ( item.matrix.includes('KTT') ) {
            return 'Kepala Teknik Tambang'
        } else {
            return item.title
        }
    }
  },
  watch: {
    approvalDialog2 (val) {
            if (!val) return;
            const NewFormData = {
                ipNo : this.ip.ipNo,
                date: new Date(),
                status : parseInt(this.approval),
                comment : this.comment,
                approvalUser : this.approvalUser
            }
            const config = {
                method: "post",
                url: `${this.API_URL}/v1/requests/approvalTamu`,
                headers: {"Authorization": `Bearer ${this.$store.state.token}`},
                data: NewFormData
            };
            axios(config).then(res => {
                // console.log(res)
                if (res.status == 200) {
                    setTimeout(() => {
                        this.dialog2 = false;
                        this.dialog = false;
                        location.reload();
                    },
                    1000);
                }
            }).catch(error => {
                handleGlobalErrorApproval(error, {
                    setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                    showSnackbar: (show) => { this.snackbar = show; },
                    closeModals: () => { 
                        this.approvalDialog = false; 
                        this.approvalDialog2 = false; 
                    },
                    disableLoader: () => { 
                        this.$store.state.loader = false;
                    },
                });
            });
    }
  }
};
</script>
<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    text-align: center;
    padding: 5px;
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}

.custom__position-for{
  font-size: 8px; 
  font-style: italic; 
  position: absolute; 
  bottom: 0; 
  left: 0;
}
</style>